import React from 'react';
import { formatAmount, isIntlFormat, isZeroDifference } from './beneficiaryValidationHelpers';

const Tile = ({ label, value, caption, className = '', onClick, active }) => (
  <div
    className={`bv-tile ${className} ${onClick ? 'bv-tile-clickable' : ''} ${active ? 'bv-tile-active' : ''}`}
    onClick={onClick}
    role={onClick ? 'button' : undefined}
    title={onClick ? 'Click to show mismatches only' : undefined}
  >
    <div className="bv-tile-label">{label}</div>
    <div className="bv-tile-value">{value}</div>
    {caption ? <div className="bv-tile-caption">{caption}</div> : null}
  </div>
);

const SummaryStrip = ({ totals, bankFormat, mismatchesOnly, onMismatchClick }) => {
  if (!totals) return null;
  const showDifference = !isIntlFormat(bankFormat);
  const ok = isZeroDifference(totals.difference);
  const nonNumeric = Number(totals.nonNumericBankAmounts || 0);

  return (
    <div className="bv-tiles mb-3">
      <Tile label="Rows" value={totals.rowCountTotal ?? 0} />
      <Tile label="Mismatches" value={totals.mismatchCount ?? 0} onClick={onMismatchClick} active={mismatchesOnly} />
      <Tile label="Not matched" value={totals.unmatchedCount ?? 0} />
      {showDifference ? (
        <Tile
          label="Difference"
          value={formatAmount(totals.difference) || '0.000'}
          className={`bv-tile-diff ${ok ? 'bv-tile-ok' : 'bv-tile-warn'}`}
          caption={
            nonNumeric > 0
              ? `${nonNumeric} bank row(s) had an amount that is not a number; they count as 0 in the total.`
              : null
          }
        />
      ) : null}
    </div>
  );
};

export default SummaryStrip;
